import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { H3 } from '@osmosis/tailwind-ui/components/Text';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';

import themeSchema, {
  getTailwindTextColorForTheme,
  themeToTailwindClassMap,
} from '../../../lib/composer/schemas/theme';
import {
  linksHeaderTextSchema,
  resourceLinksSchema,
  resourcesHeaderTextSchema,
  resourcesSchema,
} from '../../../lib/composer/schemas/resources';

type Props = {
  resources: { citation: string }[];
  links: { url: string; title: string }[];
  resourcesHeaderText: string;
  linksHeaderText: string;
  alignment: string;
  width: string;
  theme: string;
};

/**
 * Resources block for answer pages
 * @returns
 */
const Resources = (props: Props) => {
  const {
    resources,
    links,
    resourcesHeaderText,
    linksHeaderText,
    theme = 'legacy',
  } = props;
  const bgTheme = themeToTailwindClassMap[theme];
  const textColor = getTailwindTextColorForTheme(theme);
  const bgImage = theme === 'legacy' ? 'bg-legacy' : '';
  return (
    <Flex cn={cn('w-full justify-center py-5', bgTheme, bgImage)}>
      <Flex cn={cn('flex-col gap-3 max-w-[860px]')}>
        <H3 cn={cn(textColor)}>{linksHeaderText}</H3>
        <Flex cn={cn('flex-col', textColor)}>
          {links.map((link, index) => (
            <a key={index} href={link.url} className="underline">
              {link.title}
            </a>
          ))}
        </Flex>

        <H3 cn={cn(textColor)}>{resourcesHeaderText}</H3>
        <Flex cn={cn('flex-col', textColor)}>
          {resources.map(({ citation }, index) => (
            <div key={index} dangerouslySetInnerHTML={{ __html: citation }} />
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Resources;

Resources.schema = {
  name: 'resources',
  label: 'Resources',
  editableProps: [
    resourcesHeaderTextSchema,
    resourcesSchema,
    linksHeaderTextSchema,
    resourceLinksSchema,
    themeSchema,
  ],
};
